module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/mv_img-d1e91272acbd2f52031715dc719e4b47.png";